import { Breadcrumb, BreadcrumbProps, Icon, Span } from "@goodfill/ui-components";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type Props = BreadcrumbProps;

interface IBackButtonProps {
  label: string;
  onClick: () => void;
}
const BackButton: FC<IBackButtonProps> = ({ label, onClick }) => (
  <div className="flex items-center w-24">
    <Span size="xs" onClick={onClick}>
      <Icon name="caret-left" />
    </Span>
    <Span font="medium" uppercase={true} size="xs" onClick={onClick}>
      {label}
    </Span>
  </div>
);

export const BreadcrumbNavigation: FC<Props> = ({ items }) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const onClickBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const backLabel = t("back");

  return (
    <div className="gap-1 my-2 md:my-3 flex">
      {/* don't show back button if we don't have history */}
      {window.history.length > 1 ? <BackButton label={backLabel} onClick={onClickBack} /> : null}

      {items.length > 0 && (
        <div className="mx-1 md:mx-2 flex">
          <Breadcrumb items={items} />
        </div>
      )}
    </div>
  );
};
